import { featureFlags } from "@kaggle/sdk";
import { AcceleratorType } from "@kaggle/sdk/kernels";

export const DEFAULT_GPU = AcceleratorType.GPU;
export const DEFAULT_TPU = AcceleratorType.TPU1VM_V3_8;

export const hasAccelerator = (accelerator: AcceleratorType) => {
  return accelerator !== AcceleratorType.NONE;
};

export const isGpuAccelerator = (accelerator: AcceleratorType) => {
  return (
    accelerator === AcceleratorType.GPU ||
    accelerator === AcceleratorType.NVIDIA_TESLA_T4 ||
    accelerator === AcceleratorType.NVIDIA_TESLA_A100
  );
};

export const isTpuAccelerator = (accelerator: AcceleratorType) => {
  return isTpuNodeAccelerator(accelerator) || isTpu1VMAccelerator(accelerator);
};

export const isTpuNodeAccelerator = (accelerator: AcceleratorType) => {
  return (
    accelerator === AcceleratorType.TPU_V3_8 ||
    accelerator === AcceleratorType.TPU_V2_32 ||
    accelerator === AcceleratorType.TPU_V2_256
  );
};

export const isTpu1VMAccelerator = (accelerator: AcceleratorType) => {
  return accelerator === AcceleratorType.TPU1VM_V3_8;
};

const rAcceleratorAllowed = (accelerator: AcceleratorType) => {
  return !isTpuAccelerator(accelerator);
};

const acceleratorAllowed = (accelerator: AcceleratorType) => {
  if (accelerator === AcceleratorType.NVIDIA_TESLA_A100) {
    return featureFlags.kernelsA100GPUs;
  }
  return true;
};

const ACCELERATOR_OPTIONS = [
  AcceleratorType.NONE,
  AcceleratorType.NVIDIA_TESLA_T4,
  AcceleratorType.GPU,
  AcceleratorType.TPU1VM_V3_8,
  AcceleratorType.NVIDIA_TESLA_A100,
].filter(acceleratorAllowed);

export const PYTHON_ACCELERATOR_OPTIONS = ACCELERATOR_OPTIONS;

export const R_ACCELERATOR_OPTIONS =
  ACCELERATOR_OPTIONS.filter(rAcceleratorAllowed);
